
function tokyvideoATH(_athlang)
{
    addToHomescreen(
    {
        skipFirstVisit:      true,
        maxDisplayCount:     0,
        displayPace:         2 * 24 * 60,
        detectHomescreen:    'hash',
        privateModeOverride: true,
        fontSize:            12,
        language:            _athlang
    });
}
